export default __webpack_public_path__ + "static/media/cushion.8abcafca.jpg";